import { render } from "./FirstHeader.vue?vue&type=template&id=23b9d679&scoped=true"
import script from "./FirstHeader.vue?vue&type=script&lang=js"
export * from "./FirstHeader.vue?vue&type=script&lang=js"

import "./FirstHeader.vue?vue&type=style&index=0&id=23b9d679&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b9d679"]])

export default __exports__